import { render, staticRenderFns } from "./ServerItem.vue?vue&type=template&id=1dacf520&scoped=true&"
import script from "./ServerItem.vue?vue&type=script&lang=js&"
export * from "./ServerItem.vue?vue&type=script&lang=js&"
import style0 from "./ServerItem.vue?vue&type=style&index=0&id=1dacf520&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dacf520",
  null
  
)

export default component.exports